import { type Locale, setLocale } from "@web/i18n";
import { cn } from "@web/lib/utils";
import { useTranslation } from "react-i18next";

/** Two-option segmented toggle. Remembered per browser. */
export function LanguageToggle({ className }: { className?: string }) {
  const { t, i18n } = useTranslation();
  const current = (i18n.language === "en" ? "en" : "zh-TW") as Locale;
  const opts: Locale[] = ["zh-TW", "en"];
  return (
    <fieldset
      aria-label={t("language")}
      className={cn("inline-flex rounded-md border border-line p-0.5 text-xs", className)}
    >
      {opts.map((l) => (
        <button
          key={l}
          type="button"
          aria-pressed={current === l}
          onClick={() => setLocale(l)}
          className={cn(
            "rounded-[4px] px-2 py-1 font-medium transition-colors",
            current === l ? "bg-ink text-ink-inverse" : "text-ink-2 hover:text-ink",
          )}
        >
          {l === "en" ? "EN" : "中"}
        </button>
      ))}
    </fieldset>
  );
}
